__turbopack_context__.v({
  "className": "anton_922dc57e-module__2jNwUa__className",
});
